import { BoxMenuThemeSizeConfig } from './types';

const medium: BoxMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default medium;
